import { MutableRefObject, useEffect, useRef, useState } from 'react'

const useClickOutside = () => {
  const ref: MutableRefObject<HTMLDivElement | null> = useRef(null)
  const [isOpen, setIsOpen] = useState(false)
  useEffect(() => {
    const checkIfClickedOutside = (e: MouseEvent) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (isNode(e.target)) {
        if (isOpen && ref.current && e.target && !ref.current.contains(e.target)) {
          setIsOpen(false)
        }
      }
    }
    document.addEventListener('mousedown', checkIfClickedOutside)
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside)
    }
  }, [isOpen, setIsOpen])
  return { ref, isOpen, setIsOpen }
}

function isNode(e: EventTarget | null): e is Node {
  if (e && 'nodeType' in e) {
    return true
  }
  return false
}

export default useClickOutside
